import { FC } from "react";

const InlineSpinner: FC = () => {
  return (
    <div
      style={{
        width: 33,
        textAlign: "center",
      }}
    >
      <span className="preloader"></span>
    </div>
  );
};

export default InlineSpinner;
